import * as React from "react";

import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import { Input } from "@progress/kendo-react-inputs";
import { IFeedSite } from "../../classes/FeedSite";
import { removeSpecialChars } from "../../classes/StringHelper";
import { ConfirmDialog } from "../Dialogs";

interface IProps {
    allFeedNames: Array<{feedId: string, feedName: string}>;
    feedId: string;
    feedName: string;
    onSave: () => void;
    onCancel: () => void;
    serverId: number;
    sites: IFeedSite[];
    title: string;
    updateFeedName: (feedName: string) => void;
    updateSites: (sites: IFeedSite[]) => void;
}

interface IState {
    feedNameIsDuplicated: boolean;
    feedNameIsEmpty: boolean;
    isConfirmDeleteOpen: boolean;
    isConfirmPublishAllOpen: boolean;
    isConfirmPublishOpen: boolean;
    isConfirmSubscribeAllOpen: boolean;
    isConfirmSubscribeOpen: boolean;
    selectedServerId: number;
}

export default class FeedEditModal extends React.Component<IProps, IState> {
    public constructor(props) {
        super(props);
        this.state = {
            feedNameIsDuplicated: false,
            feedNameIsEmpty: false,
            isConfirmDeleteOpen: false,
            isConfirmPublishAllOpen: false,
            isConfirmPublishOpen: false,
            isConfirmSubscribeAllOpen: false,
            isConfirmSubscribeOpen: false,
            selectedServerId: null,
        };
    }

    public render() {
        return (
            <Dialog
                title={this.props.title}
                onClose={() => this.props.onCancel()}
                width={500}
            >
                <this.feedNameEditor />
                <this.feedSites />

                <div style={{ clear : "both" }}>
                    <ul>
                        <li><b>Publish:</b> Newsrooms on these sites may <b>publish</b> articles to this Feed.</li>
                        <li><b>Subscribe:</b> Newsrooms on these sites may <b>subscribe</b> to articles published to this Feed.</li>
                    </ul>
                </div>

                {this.state.feedNameIsDuplicated &&
                    <div style={{ margin: "10px", color: "red" }}>
                        The Feed Name already exists. Plese enter a unique Feed Name
                    </div>
                }
                <this.actionsBar />
            </Dialog>
        );
    }

    private feedNameEditor = () => {
        return (
            <>
                <div style={{ margin: "10px" }}>
                    <Input
                        type="text"
                        placeholder="Feed name"
                        autoFocus={true}
                        value={this.props.feedName}
                        onChange={(e) => this.onChangeFeedName(e)}
                        style={{ width: "100%" }}
                        maxLength={50}
                    />
                </div>
                {this.state.feedNameIsEmpty &&
                    <div style={{ margin: "10px", color: "red" }}>
                        Feed Name is required.
                    </div>
                }
            </>
        );
    }

    private feedSites = () => {
        return (
            <div>
                Sites which can publish/subscribe to this Feed:
                <Grid
                    style={{ height: "250px" }}
                    data={this.props.sites.map((item) =>
                        ({ ...item, inEdit: true }),
                    )}
                    pageable={false}
                    editField="inEdit"
                    onItemChange={this.onItemChange.bind(this)}
                >
                    <GridColumn field="serverName" width="259px" title="Server Name" editable={false}/>
                    <GridColumn field="isPublished" width="94px" title="Publish" editor="boolean" />
                    <GridColumn field="isSubscribed" width="94px" title="Subscribe" editor="boolean" />
                </Grid>

                <this.confirmPublish />
                <this.confirmUnsubscribe />
                <div style={{ margin: "10px 0px 0px 0px"}}>
                    <this.publishAll />
                    <this.subscribeAll />
                </div>
            </div>
        );
    }

    private confirmPublish = () => {
        return (
            <ConfirmDialog
                isOpen={this.state.isConfirmPublishOpen}
                message={"A Feed that can publish articles to a site will also be set to subscribe to the articles published to that site."}
                callBack={ (value) => {
                    if (value) {
                        const data = [];
                        this.props.sites.map((item) => {

                            if ( item.serverId === this.state.selectedServerId ) {
                                item.isPublished = true;
                                item.isSubscribed = true;
                            }

                            data.push(item);
                        });
                        this.props.updateSites(data);
                    }
                    this.setState({ isConfirmPublishOpen: false, selectedServerId: null });
                }}
            />
        );
    }

    private confirmUnsubscribe = () => {
        return (
            <ConfirmDialog
                isOpen={this.state.isConfirmSubscribeOpen}
                message={"A Feed that is no longer set to subscribe to the articles published to a site will also be set to no longer Publish articles to that site."}
                callBack={ (value) => {
                    if (value) {
                        const data = [];
                        this.props.sites.map((item) => {

                            if ( item.serverId === this.state.selectedServerId ) {
                                item.isPublished = false;
                                item.isSubscribed = false;
                            }

                            data.push(item);
                        });
                        this.props.updateSites(data);
                    }
                    this.setState({ isConfirmSubscribeOpen: false, selectedServerId: null });
                }}
            />
        );
    }

    private publishAll = () => {
        return (
            <div style={{ padding: "0px 0px 10px 285px", float: "left" }}>
                <button
                    className="CMS_button"
                    onClick={(e) => {
                        this.onPublishAll(e);
                    }}
                >
                    All
                </button>
                <ConfirmDialog
                    isOpen={this.state.isConfirmPublishAllOpen}
                    message={"If the Feed can publish articles to all the sites, then the feed will also be set to subscribe to all the articles published to all the sites."}
                    callBack={ (value) => {
                        if (value) {
                            const data = [];
                            this.props.sites.map((item) => {
                                item.isPublished = true;
                                item.isSubscribed = true;

                                data.push(item);
                            });
                            this.props.updateSites(data);
                        }
                        this.setState({ isConfirmPublishAllOpen: false });
                    }}
                />
            </div>
        );
    }

    private subscribeAll = () => {
        return (
            <div style={{ float: "right", width : "20%" }}>
                <button
                    className="CMS_button"
                    onClick={this.onSubscribeAll.bind(this)}
                    >
                    All
                </button>
                <ConfirmDialog
                    isOpen={this.state.isConfirmSubscribeAllOpen}
                    message={"If the Feed cannot subscribe to the articles published to any sites, then the feed will also be set not to publish articles to any sites."}
                    callBack={ (value) => {
                        if (value) {
                            const data = [];
                            this.props.sites.map((item) => {
                                item.isPublished = false;
                                item.isSubscribed = false;
                                data.push(item);
                            });

                            this.props.updateSites(data);
                        }
                        this.setState({ isConfirmSubscribeAllOpen: false });
                }}
                />
            </div>
        );
    }

    private actionsBar = () => {
        return (
            <DialogActionsBar>
                <button
                    className="k-button"
                    onClick={(e) => {
                        e.preventDefault();
                        this.props.onCancel();
                    }}
                    title="Cancel"
                >
                    Cancel
                </button>

                <button
                    className="k-button"
                    onClick={async (e) => {
                        e.preventDefault();
                        if (this.validateFeedName(this.props.feedName)) {
                            this.props.onSave();
                        }
                    }}
                    title="OK"
                    disabled={this.state.feedNameIsDuplicated || this.state.feedNameIsEmpty}
                >
                    OK
                </button>
            </DialogActionsBar>
        );
    }

    private onChangeFeedName(e) {
        const newFeedName = removeSpecialChars(e.target.value);
        this.props.updateFeedName(newFeedName);

        this.validateFeedName(newFeedName);
    }

    private validateFeedName(newFeedName: string): boolean {
        const isDuplicated = this.props.allFeedNames.filter((f) =>
            f.feedId !== this.props.feedId &&
            f.feedName.toLowerCase() === newFeedName.toLowerCase(),
        ).length > 0;
        const isEmpty = newFeedName.length === 0;
        this.setState({ feedNameIsDuplicated: isDuplicated, feedNameIsEmpty: isEmpty });
        return !isDuplicated && !isEmpty;
    }

    private onItemChange(e) {
        const data = [];
        let setStateValue = true;

        this.props.sites.map((item) => {

            if ( item.serverId === e.dataItem.serverId ) {
                if (e.field === "isPublished") {
                    if (e.value === true) {
                        if (item.isSubscribed === false) {
                            setStateValue = false;
                            this.setState({ isConfirmPublishOpen: true, selectedServerId: item.serverId});
                        } else {
                            item.isPublished = true;
                        }
                    } else {
                        item.isPublished = e.value;
                    }
                } else {
                    if (e.field === "isSubscribed") {
                        if (e.value === false) {
                            if (item.isPublished === true) {
                                setStateValue = false;
                                this.setState({ isConfirmSubscribeOpen: true, selectedServerId: item.serverId});
                            } else {
                                item.isSubscribed = false;
                            }
                        } else {
                            item.isSubscribed = e.value;
                        }
                    }
                }
            }

            data.push(item);
        });

        if ( setStateValue ) {
            this.props.updateSites(data);
        }
    }

    private onPublishAll(e) {
        let hasFalseChecked = false;
        const data = [];

        for (const site of this.props.sites) {
            if (site.isPublished === false) {
                hasFalseChecked = true;
            }
        }

        if (hasFalseChecked === true) {
            this.setState({ isConfirmPublishAllOpen: true });
        } else {
            this.props.sites.map((item) => {
                if ( item.serverId !== this.props.serverId ) {
                    item.isPublished = false;
                }

                data.push(item);
            });

            this.props.updateSites(data);
        }
    }

    private onSubscribeAll(e) {
        let hasFalseChecked = false;
        const data = [];
        e.preventDefault();

        for (const site of this.props.sites) {
            if (site.isSubscribed === false && site.serverId !== this.props.serverId) {
                hasFalseChecked = true;
            }
        }

        if (hasFalseChecked === false) {
            this.setState({ isConfirmSubscribeAllOpen: true });
        } else {
            this.props.sites.map((item) => {
                item.isSubscribed = true;

                data.push(item);
            });

            this.props.updateSites(data);
        }
    }

}
